import { isEmpty } from 'lodash-es';

export const can = (ability, user) => {
	if (isEmpty(user)) {
		return false;
	}

	const permissions = user.memberships[0].role.permissions
	// permissions is now an array of strings, not objects
	return permissions.includes(ability[0])
}
// import _ from 'lodash'
//
// export const hasRole = (value, role) => true || !!_.find(role, { value: value })
// export const hasrole = (values, role) =>
// 	true || !!_.filter(values, value => hasRole(value, role)).length
